<metering-issues-summary-grid-item></metering-issues-summary-grid-item>
<div class="flex-grid end stack-sm">
    <div class="flex-grid--item organise-select">
        <form action="" class="module-form">
            <div class="form-group">
                <label for="">Site</label>
                <select name="siteId" id="" class="select__standalone" [(ngModel)]="selectedSiteId" (change)="updateSite()" #siteId>
                    <option [ngValue]="0">All</option>
                    <option [ngValue]="site.siteId" *ngFor="let site of sites">{{site.siteName}}</option>
                </select>
            </div>
        </form>
    </div>
</div>
<masonry [masonryItems]="masonryItems" [masonryColumnCount]="2"></masonry>
